import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import {
    RenderNumber,
    RenderKilogramo,
} from "../../../../../../Utils/renderField/renderReadField";
const verIcon = require("assets/img/icons/ver.png");

export const TrasladosTable = ({ traslados }) => {
    return (
        <div className="new-table-wrapper historial-control-calidad__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Fecha - hora</th>
                        <th>Número</th>
                        <th>Tipo de traslado</th>
                        <th>Usuario</th>
                        <th>Cant. pallets</th>
                        <th>Cant. pacas</th>
                        <th>Kg secos sobrantes</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {traslados.length === 0 && (
                        <tr>
                            <td colSpan={8} className="text-center">
                                No hay registros de traslados de control de calidad
                            </td>
                        </tr>
                    )}
                    {traslados.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center text-nowrap">
                                    {item.fecha_con_desfase
                                        ? moment(item.fecha_con_desfase).format(
                                              "DD/MM/YYYY - HH:mm",
                                          )
                                        : "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.numero}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.tipo_traslado_display}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.usuario_nombre || "No definido"}
                                </td>
                                <td className="text-center">
                                    <RenderNumber
                                        value={item.total_pallets}
                                        decimalScale={0}
                                    />
                                </td>
                                <td className="text-center">
                                    <RenderNumber
                                        value={item.total_pacas_trasladadas}
                                        decimalScale={0}
                                    />
                                </td>
                                <td className="text-center">
                                    <RenderKilogramo
                                        value={item.total_kg_secos_trasladados}
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <Link
                                        to={`/produccion-bodega/control-calidad/${item.id}/ver-boleta`}
                                    >
                                        <img
                                            src={verIcon}
                                            alt="Ver"
                                            className="action_img"
                                            title="Ver"
                                        />
                                    </Link>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
